module.exports = __webpack_public_path__ + "assets/images/project/icon/consti_icon.svg?v=32a79c17";